export const USER_STATUS = Object.freeze({
  ACTIVE: true,
  INACTIVE: false,
});
